import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const getAdminToken = () => {
  try {
    return localStorage.getItem("sgc_admin_token");
  } catch {
    return null;
  }
};

export const setAdminToken = (t) => {
  try {
    if (t) localStorage.setItem("sgc_admin_token", t);
    else localStorage.removeItem("sgc_admin_token");
  } catch {}
};

api.interceptors.request.use((cfg) => {
  const t = getAdminToken();
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export function formatApiErrorDetail(e) {
  const detail = e?.response?.data?.detail ?? e?.message;
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((x) => (x && typeof x.msg === "string" ? x.msg : JSON.stringify(x)))
      .filter(Boolean)
      .join(", ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const resolveImg = (photo) =>
  photo?.kind === "storage" ? `${API}/gallery/file/${photo.id}` : photo?.url;

let lenisRef = null;
export const setLenis = (l) => {
  lenisRef = l;
};
export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (lenisRef) lenisRef.scrollTo(el, { offset: -72, duration: 1.4 });
  else el.scrollIntoView({ behavior: "smooth" });
};
